export default __webpack_public_path__ + "static/media/Product-Id.c26225c4.jpg";